export var HTTP_MOCK_SERVER_URL = 'http://localhost:5600';
export var NO_SCENARIO_FOUND = 'NO_SCENARIO_FOUND';
export var SSR_HOST = 'www.wix.com';
//# sourceMappingURL=constants.js.map